module.exports = __webpack_public_path__ + "static/media/logo-min.12cb4d99.svg";